// custom typefaces

// normalize CSS across browsers
import "./src/css/normalize.css";

// custom CSS styles
import "./src/css/style.scss";

import React from "react";
import { LocationProvider } from "./src/context/LocationContext"; // Import the provider
import { PreviewProvider } from "./src/context/PreviewContext";
import { UserProvider } from "./src/context/UserContext"; // Import the UserProvider

// Disable console logs in production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// Wrapping the root element with LocationProvider to pass context
export const wrapRootElement = ({ element }) => {
  return (
    <LocationProvider>
      <PreviewProvider>
        <UserProvider>{element}</UserProvider>
      </PreviewProvider>
    </LocationProvider>
  );
};

// Custom scroll behavior to scroll to the top
export const onRouteUpdate = () => {
  const contentWrapper = document.querySelector(".contentWrapper");
  if (contentWrapper) {
    contentWrapper.scrollTop = 0;
  }

  const pageWrapper = document.querySelector(".pageWrapper");
  if (pageWrapper) {
    pageWrapper.scrollTop = 0;
  }
};
